export class RecentActivitiesLabelEN {

    title: string;
    newRecord: string;
    quotationId: string;
    quotationIs: string;
    notGenerated: string;
    loading: string;
    wait: string;

    constructor() {
        this.title = "My Recent Activities";
        this.newRecord = "A new record has been Created or updated for ";
        this.quotationId = "Quotation Id is ";
        this.quotationIs = "Quotation is ";
        this.notGenerated = "Not Generated";
        this.loading = "Loading...";
        this.wait = "Recent Activities are being loaded please wait. ";
    }
}
